import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(({ px, palette, tokens }) => ({
  addressInput: {
    width: '100%',
    marginBottom: tokens.spacing['16'],
  },

  clearIndicatorHide: {
    visibility: 'hidden !important',
    opacity: '0 !important',
    pointerEvents: 'none !important',
  } as never,

  inputRoot: {
    '& .MuiInputBase-root': {
      paddingRight: 0,
      lineHeight: 1.5,
      backgroundColor: tokens.colors.bg.light.primary,

      '&.MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
        padding: 0,
      },

      '&.MuiOutlinedInput-root.MuiAutocomplete-inputRoot .MuiInputBase-input, &.MuiOutlinedInput-root .MuiSelect-root':
        {
          height: px(24),
          paddingTop: tokens.spacing['16'],
          paddingRight: tokens.spacing['72'],
          paddingBottom: tokens.spacing['16'],
          paddingLeft: tokens.spacing['16'],
        },

      '& .MuiSelect-iconOutlined': {
        right: tokens.spacing['16'],
      },

      '&.Mui-focused': {
        '& fieldset': {
          borderColor: tokens.colors.original.brand.primary,
          borderWidth: tokens.border.s,
        },
        '& .MuiAutocomplete-clearIndicator': {
          visibility: 'visible',
          opacity: '1',
          pointerEvents: 'auto',
        },
      },

      '&.Mui-error': {
        backgroundColor: tokens.colors.accent.bg.error,

        '&:hover': {
          '& fieldset': {
            borderColor: palette.error.hover,
          },
        },

        '& fieldset': {
          borderColor: tokens.colors.accent.stroke.error,
        },

        '&.Mui-focused': {
          '& fieldset': {
            borderColor: tokens.colors.accent.text.error,
          },
        },
      },

      '&.Mui-disabled': {
        backgroundColor: tokens.colors.bg.greyscale.secondary,
        pointerEvents: 'none',

        '& fieldset': {
          borderColor: tokens.colors.stroke.primary,
        },
      },

      '& fieldset': {
        borderColor: tokens.colors.stroke.primary,
      },

      '&:hover:not(.Mui-disabled)': {
        '&:not(.Mui-error):not(.Mui-focused) fieldset': {
          borderColor: tokens.colors.stroke.secondary,
        },
        '& .MuiAutocomplete-clearIndicator': {
          visibility: 'visible',
          opacity: '1',
          pointerEvents: 'auto',
        },
      },

      '& .MuiIconButton-root:hover': {
        backgroundColor: 'transparent',
      },

      '& .MuiAutocomplete-endAdornment': {
        right: tokens.spacing['16'],

        '& .MuiAutocomplete-clearIndicator': {
          marginRight: -tokens.spacing['2'],
          backgroundColor: 'transparent',

          '& .MuiTouchRipple-root': {
            display: 'none',
          },
        },

        '& .MuiAutocomplete-popupIndicator .MuiTouchRipple-root': {
          display: 'none',
        },
      },
    },

    '& .MuiFormHelperText-root': {
      marginLeft: 0,
      marginRight: 0,
    },
    '& .MuiAutocomplete-popupIndicator': {
      display: 'none',
    },
  },

  paper: {
    boxShadow: tokens.shadow.l,
    maxHeight: px(276),
    marginTop: tokens.spacing[4],
    marginBottom: tokens.spacing[4],

    scrollbarWidth: 'none',

    '&:empty': {
      border: 'none',
      boxShadow: 'none',
    },
  },

  option: {
    paddingTop: tokens.spacing['12'] + px(2),
    paddingRight: tokens.spacing['16'],
    paddingBottom: tokens.spacing['12'] + px(2),
    paddingLeft: tokens.spacing['16'],
    fontSize: tokens.typography.variant.body3.fontSize,
    lineHeight: tokens.typography.variant.body3.lineHeight,
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: tokens.colors.bg.greyscale.secondary,
    },

    '&[aria-selected=true]': {
      color: tokens.colors.original.brand.primary,
      backgroundColor: tokens.colors.bg.light.primary,

      '&:hover': {
        backgroundColor: tokens.colors.bg.greyscale.secondary,
      },
    },
  },
}));

export default useStyles;
